import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'



const teachers = [

    
        {
            "Name": "Gavvala Gowthami",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2023",
            "AreasofResearch": "ML for IoT",
            "GuideName": "Dr. V. Mahendran",
            "GuideLink": "/dr-v-mahendran",
            "Email": "cs23d003@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/Gowthami.jpg"
        },

        {
            "Name": "Vinupriya R",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2023",
            "AreasofResearch": "Computer Networks",
            "GuideName": "Dr. V. Mahendran",
            "GuideLink": "/dr-v-mahendran",
            "Email": "cs23d002@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/Vinupriya-R.jpg"
        },
        {
            "Name": "Abhijit Kumar Sahu",
            "Position": "M.S (Research) Scholar",
            "Batch": "July 2022",
            "AreasofResearch": "Algorithm Engineering",
            "GuideName": "Dr G Ramakrishna",
            "GuideLink": "/dr-g-ramakrishna",
            "Email": "CS22S501@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/cs22s501.jpg"
        },
        {
            "Name": "Deep Kumar Ganguly",
            "Position": "M.S (Research) Scholar",
            "Batch": "July 2022",
            "AreasofResearch": "Reinforcement Learning",
            "GuideName": "Dr Ajin George Joseph",
            "GuideLink": "/dr-ajin-george-joseph",
            "Email": "CS22S502@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/cs22s502.jpg"
        },
        {
            "Name": "Jahnavi K",
            "Position": "M.S (Research) Scholar",
            "Batch": "July 2022",
            "AreasofResearch": "Software Engineering",
            "GuideName": "Dr Sridhar Chimalakonda",
            "GuideLink": "/dr-sridhar-chimalakonda",
            "Email": "CS22S503@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/cs22s503.jpg"
        },
        {
            "Name": "Rajrupa Chattaraj",
            "Position": "M.S (Research) Scholar",
            "Batch": "July 2022",
            "AreasofResearch": "Software Engineering",
            "GuideName": "Dr Sridhar Chimalakonda",
            "GuideLink": "/dr-sridhar-chimalakonda",
            "Email": "CS22S504@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/cs22s504.jpg"
        },
        {
            "Name": "Prabhleen Kukreja",
            "Position": "Ph.D Scholar",
            "Batch": "July 2021",
            "AreasofResearch": "ML for IoT",
            "GuideName": "Dr. V. Mahendran",
            "GuideLink": "/dr-v-mahendran",
            "Email": "CS21D503@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/CS21D503 PRABHLEEN KUKREJA.jpeg"
        },
        {
            "Name": "Goli Nageswararao",
            "Position": "Ph.D Scholar",
            "Batch": "July 2021",
            "AreasofResearch": "Computer Networks",
            "GuideName": "Prof. Venkata Ramana Badarla",
            "GuideLink": "/dr-venkata-ramana-badarla",
            "Email": "cs21d502@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/nageswarao.jpg"
        },
        {
            "Name": "Chetan Sharma",
            "Position": "Ph.D Scholar",
            "Batch": "July 2021",
            "AreasofResearch": "Data Science",
            "GuideName": "Dr. Kalidas Yeturu",
            "GuideLink": "/dr-kalidas-yeturu",
            "Email": "cs21d501@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/Chetan.jpg"
        },
        {
            "Name": "Vikas Kumar",
            "Position": "M.S (Research) Scholar",
            "Batch": "Jan 2021",
            "AreasofResearch": "Reinforcement Learning",
            "GuideName": "Dr. Ajin George Joseph",
            "GuideLink": "/dr-ajin-george-joseph",
            "Email": "cs21s001@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/vikas.png"
        },
        {
            "Name": "Aditi Palit",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2021",
            "AreasofResearch": "Machine Learning Algorithms and Applications",
            "GuideName": "Dr. Kalidas Yeturu",
            "GuideLink": "/dr-kalidas-yeturu",
            "Email": "cs21d001@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/aditi.jpg"
        },
        {
            "Name": "Sai Prem Kumar Ayyagari",
            "Position": "Ph.D Scholar - External",
            "Batch": "Jul 2020",
            "AreasofResearch": "Machine Learning",
            "GuideName": "Dr. Y. Kalidas",
            "GuideLink": "/dr-kalidas-yeturu",
            "Email": "CS19D502@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/CS19D502%20Saiprem%20Kumar%20Ayyagari.jpeg"
        },
        {
            "Name": "Shriram Shridhar Shanbhag",
            "Position": "M.S (Research) Scholar",
            "Batch": "Jul 2020",
            "AreasofResearch": "Software Engineering",
            "GuideName": "Dr. Sridhar Chimalakonda",
            "GuideLink": "/dr-sridhar-chimalakonda",
            "Email": "CS20S503@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/CS20S503%20Shriram%20Shridhar%20Shanbhag.JPG"
        }, {
            "Name": "Akhila Sri Manasa",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2020",
            "AreasofResearch": "Software Engineering",
            "GuideName": "Dr. Sridhar Chimalakonda",
            "GuideLink": "/dr-sridhar-chimalakonda",
            "Email": "cs19d504@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/manasar.jpg"
        },
        {
            "Name": "Tharakeswara Raju B",
            "Position": "Ph.D Scholar",
            "Batch": "Jul 2019",
            "AreasofResearch": "Wireless Networks",
            "GuideName": "Prof. Venkata Ramana Badarla",
            "GuideLink": "/dr-venkata-ramana-badarla",
            "Email": "CS19D503@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/CS19D503_Tharakeswara Raju.jpg"
        },
        {
            "Name": "Naresh Babu Kakarla",
            "Position": "Ph.D Scholar",
            "Batch": "July 2019",
            "AreasofResearch": "Computer Networks",
            "GuideName": "Dr. V. Mahendran",
            "GuideLink": "/dr-v-mahendran",
            "Email": "cs19d501@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/NareshBabuKakarla.JPG"
        },
        {
            "Name": "A Eashaan Rao",
            "Position": "Ph.D Scholar",
            "Batch": "July 2019",
            "AreasofResearch": "Software Engineering",
            "GuideName": "Dr. Sridhar Chimalakonda",
            "GuideLink": "/dr-sridhar-chimalakonda",
            "Email": "cs19s501@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/eeshan.jpeg"
        },
        {
            "Name": "G V Sumukha Bharadwaj",
            "Position": "Ph.D Scholar",
            "Batch": "July 2019",
            "AreasofResearch": "Computational Complexity",
            "GuideName": "Dr. S Raja",
            "GuideLink": "/dr-s-raja",
            "Email": "cs19s502@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/GVSumukhaBharadwaj.jpg"
        },
        {
            "Name": "Mithinti Srikanth",
            "Position": "Ph.D Scholar",
            "Batch": "July 2018",
            "AreasofResearch": "Algorithm Engineering",
            "GuideName": "Dr. G. Ramakrishna",
            "GuideLink": "/dr-g-ramakrishna",
            "Email": "cs18d501@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/CS18D501_MITHINTISRIKANTH.jpg"
        },
        {
            "Name": "Arnab Bhadra",
            "Position": "M.S (Research) Scholar",
            "Batch": "July 2018",
            "AreasofResearch": "Machine Learning Algorithms & Applications",
            "GuideName": "Dr. Kalidas Yeturu",
            "GuideLink": "/dr-kalidas-yeturu",
            "Email": "cs18s501@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/CS18S501_ArnabBhadra.jpg"
        },
        {
            "Name": "Chirayu Anant Haryan",
            "Position": "M.S (Research) Scholar",
            "Batch": "July 2018",
            "AreasofResearch": "Algorithm Engineering",
            "GuideName": "Dr. G. Ramakrishna",
            "GuideLink": "/dr-g-ramakrishna",
            "Email": "cs18s503@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/CS18S503_ChirayuAnantHaryan.jpg"
        },
        {
            "Name": "K Prashanth",
            "Position": "M.S (Research) Scholar",
            "Batch": "July 2018",
            "AreasofResearch": "Machine Learning Algorithms and Applications",
            "GuideName": "Dr. Kalidas Yeturu",
            "GuideLink": "/dr-kalidas-yeturu",
            "Email": "cs18s504@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/cse/CS18S504_KomuravelliPrashanth.jpg"
        },
        {
            "Name": "Rohit Gupta",
            "Position": "M.S (Research) Scholar",
            "Batch": "July 2018",
            "AreasofResearch": "Computer Networks",
            "GuideName": "Dr. V. Mahendran",
            "GuideLink": "/dr-v-mahendran",
            "Email": "cs18s505@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/CS18S505_RohitGupta.jpg"
        },
        {
            "Name": "Suri Bhasker Sri Harsha",
            "Position": "M.S (Research) Scholar",
            "Batch": "July 2018",
            "AreasofResearch": "Machine Learning Algorithms and applications",
            "GuideName": "Dr. Kalidas Yeturu",
            "GuideLink": "/dr-kalidas-yeturu",
            "Email": "CS18S506@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/CS18S506_BhaskerSriHarsha.jpg"
        },
        {
            "Name": "Vamshi Vijay Krishna J",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2018",
            "AreasofResearch": "Computer Networks",
            "GuideName": "Dr. V. Mahendran",
            "GuideLink": "/dr-v-mahendran",
            "Email": "cs18d002@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/vamshikrishna.png"
        }



    



]



function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Computer Science Engineering" />
            <section className="team-area fix p-relative pt-120 pb-80">
                 
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h5>
                                    <i className="fal fa-graduation-cap" /> Research Scholars
                                </h5>
                                <h2>Computer Science Engineering</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {teachers.map((teacher, index) => (
       

                           <div key={index} className="col-xl-3 col-md-6 col-sm-6">
                                <div className="single-team mb-40">
                                    <div className="team-thumb">
                                        <div className="brd">
                                            <Link to="#">
                                                <img src={teacher.Image} alt="img" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="team-info">
                                        <h4>
                                            <Link to={teacher.namelink}>{teacher.Name}</Link>
                                        </h4>
                                       
                                        <div className="text-dark c-lineheight2">
                                            <p > <i className="fal fa-graduation-cap me-2" />{teacher.Position}</p>
                                            <p className="text-dark">{teacher.position2}</p>
                                            <p className="text-dark">Batch : {teacher.Batch}</p>
                                            <p className="text-dark">Areas of Research : {teacher.AreasofResearch}</p>
                                            
                                            {/* Parse the HTML content and extract text */}
                                            
                                            <p className="text-dark">Guide: <Link className="text-maroon" to={teacher.GuideLink} target="_blank" > {teacher.GuideName}</Link> </p>

                                            {(teacher.CoGuideName !== undefined && teacher.CoGuideName !== "") && (
                                                <p className="text-dark">Co-Guide: <a className="text-maroon" href={teacher.CoGuideLink} target="_blank" >{teacher.CoGuideName}</a></p>
                                            )}
                                            {/* <p className="text-orange"><i className="fal fa-envelope  me-2"></i> <Link to={teacher.Email} target="_blank" className="btn btn-primary">{teacher.Email}</Link></p> */}
                                            <p className="text-dark"><i className="fal fa-envelope  me-1"></i> Email : {teacher.Email}</p>
                                        </div>                                       
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default Main